import { Type } from '@api/activityApi/interfaces';
import React from 'react';
import { NewsItemPublishedActivity } from './activities/news';
import { InstructionPagePublishedActivity } from './activities/instructions';
import { RulesAndRegulationPagePublishedActivity } from './activities/rules-and-regulations';
import { NewFeedMessageActivity } from './activities/NewFeedMessageActivity';
import {
  CompetitionPublishedActivity,
  CompetitionStartedActivity,
  CompetitionCompletedActivity,
  CompetitionStoppedActivity,
  CompetitionResumedActivity,
  CompetitionRankingsChangedActivity,
} from './activities/competitions';

export const ActivityComponentMap: Record<Type, React.FC<any>> = {
  'news-item-published': NewsItemPublishedActivity,
  'instruction-page-published': InstructionPagePublishedActivity,
  'rules-and-regulations-page-published':
    RulesAndRegulationPagePublishedActivity,

  'feed-message-posted': NewFeedMessageActivity,
  'competition-published': CompetitionPublishedActivity,
  'competition-started': CompetitionStartedActivity,
  'competition-completed': CompetitionCompletedActivity,
  'competition-stopped': CompetitionStoppedActivity,
  'competition-resumed': CompetitionResumedActivity,
  'competition-rankings-changed': CompetitionRankingsChangedActivity,
};
